{
	"es": {
		"account": {
			"suspended": {
				"lineOne": "La suscripción de tu organización a CareAcademy tiene un problema de facturación.",
				"lineTwo": "El acceso a tu cuenta ha sido suspendido. Ponte en contacto con tu gerente de facturación para más información.",
				"title": "Acceso a la cuenta suspendido"
			}
		},
		"constants": {
			"incorrectMember": "Cuidador incorrecto. Por favor, contacta a la organización para más información."
		},
		"footer": {
			"copyWrite": "&copy; {{year}} CareAcademy. Todos los derechos reservados.",
			"medicalDisclaimer": "Descargo de responsabilidad médica",
			"privacyPolicy": "Declaración de privacidad",
			"termsOfService": "Términos de Servicio"
		},
		"global": {
			"add": "añadir",
			"agencies": "organizaciones",
			"agency": "organización",
			"button": {
				"continue": "Continuar",
				"getStarted": "Empezar",
				"goBack": "Regresar"
			},
			"certificate": "certificado",
			"certificates": "certificados",
			"class": "clase",
			"classes": "clases",
			"complete": "completar",
			"completed": "completado",
			"completedDate": "fecha de finalización",
			"due": "vence",
			"dueOn": "vence el",
			"login": "Iniciar Sesión",
			"logout": "Cerrar Sesión",
			"noItems": "No hay elementos",
			"notAvailable": "N/A",
			"select": "seleccionar",
			"status": {
				"complete": "completar",
				"completed": "completado"
			},
			"training": {
				"annual": "anual",
				"annualTraining": "Entrenamiento Aanual",
				"initial": "inicial",
				"initialTraining": "Entrenamiento Inicial",
				"none": "ninguno",
				"training": "entrenamiento"
			}
		},
		"member": {
			"continuingEducation": {
				"changeMessage": "Change this CNA's <i>Language</i> to English if you want their classes to be eligible for CE credit.",
				"requirementMessage": "The state of California <u>requires</u> that all Certified Nursing Assistants (CNAs) must complete classes in English to receive continuing education (CE) credit.",
				"title": "Continuing Education Credits for CNAs"
			}
		},
		"memberDashboard": {
			"agencyListing": {
				"active": "Tu <span>{{nameOfTraining}}</span> se vence el <span class='fw4-ns'>{{dueDate}}</span>",
				"inactive": {
					"lineOne": "Has sido desactivado/a por esta organización.",
					"lineTwo": "Por favor ponte en contacto con la organización para más información."
				},
				"suspended": {
					"lineOne": "El acceso a tu cuenta ha sido suspendido.",
					"lineTwo": "Por favor, comunícate con tu supervisor para obtener más información."
				}
			},
			"agencyTraining": {
				"noTraining": {
					"assignedTraining": "El entrenamiento asignado puede tardar en procesarse antes de que aparezca en tu panel de control.",
					"subtitle": "No te han inscrito en ningún entrenamiento."
				},
				"title": "¿Qué es lo que <span>sigue</span>?"
			},
			"button": {
				"add": "Añadir",
				"enroll": "Inscribir",
				"processing": "Procesando",
				"resetExam": "Reiniciar examen",
				"viewCertificates": "Ver certificados",
				"viewAllClasses": "Ver todas las clases",
				"yourAgencies": "Tus organizaciones",
				"yourCertificates": "Tus certificados",
				"videoLibrary": "Videoteca autoservicio"
			},
			"classDetails": {
				"courseCallout": {
					"class": "{{count}} clase",
					"classes": "{{count}} clases",
					"minutes": "{{duration}} minutos"
				},
				"dueDateCallout": "Para cumplir con las regulaciones estatales, tienes que completar esta clase dentro de {{days}} días después de empezarla",
				"getStarted": "Empezar",
				"nextClass": "próxima clase",
				"noCourses": "Vuelve pronto para ver cursos adicionales"
			},
			"dashboardHeader": {
				"completedTraining": "¡Has <span>completado</span> todo tu entrenamiento asignado!",
				"dueOn": "Vence: <span class='dynamic-column-header__primary-text'>{{trainingDueDate}}</span>"
			},
			"landingPage": {
				"listOfTraining": "A continuación se muestra una lista de tus <span class='dynamic-column-header__secondary-text'>organizaciones</span>.<br /><br /><span class='dynamic-column-header__secondary-text'>Selecciona una organización</span> para continuar tu entrenamiento.</p>",
				"title": "Hola <span class='dynamic-column-header__secondary-text'>{{firstName}}</span>!"
			},
			"optionalTraining": {
				"button": "Entiendo",
				"confirmation": "¡Suena bien! ¡Vamos a hacerlo!",
				"message": "Este es un entrenamiento opcional que no fue asignado por tu organización. Tienes acceso gratuito a este entrenamiento porque tu organización utiliza <span class='brand-name brand-name--alternate'><span class='brand-primary-text'>Care</span><span class='brand-secondary-text'>Academy</span></span>. Consulta directamente con tu supervisor las políticas de compensación sobre entrenamientos opcionales.",
				"title": "¿Listo para mejorar tus habilidades?<br />¡Así se hace!"
			},
			"placeholder": {
				"text": "Ir a LearnUpon"
			},
			"title": "Tablero de tu equipo",
			"trainingWithDueDate": {
				"learn": "aprende algo nuevo",
				"trainingDueOn": "Vence: <span class='member-dashboard__highlight'>{{goalDueDate}}</span>"
			},
			"trainingCompletionContent": "Has completado <span class='dynamic-column-header__secondary-text'>{{completedCourseStatusesCount}} de {{courseStatusesCount}} clases</span> hacia tu <span class='dynamic-column-header__secondary-text'>{{nameOfTraining}}</span> para <span class='dynamic-column-header__ternary-text'>{{agencyName}}</span>",
			"trainings": {
				"nextRequiredClass": "<span>Selecciona un entrenamiento</span> a continuación para ver más detalles.",
				"selfEnroll": "Selecciona el icono <svg class=\"svg-component SVGPlusCircle\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"1.5\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z\" /></svg> para añadir más entrenamiento",
				"title": "Todo tu entrenamiento"
			}
		},
		"printCertificates": {
			"completeClasses": "Los certificados aparecerán aquí una vez que completes las clases.",
			"noCertificates": "No se encontraron certificados.",
			"title": "Imprimir Certificados para Clases"
		},
		"selfEnrollment": {
			"additionalTraining": {
				"checkBack": "Vuelve pronto para nuevos programas de formación de <span class='brand-name'><span class='brand-primary-text'>Care</span><span class='brand-secondary-text'>Academy</span></span>",
				"subtitle": "Has completado toda la <span>nueva formación</span> que está disponible actualmente.",
				"title": "Entrenamiento adicional"
			},
			"button": {
				"addMoreTraining": "Agregar más formación",
				"enroll": "Inscribirse",
				"goToDashboard": "Ir al panel de control",
				"processing": "Procesando",
				"returnToDashboard": "Volver al panel de control"
			},
			"enrollmentInProgress": {
				"currentlyProcessing": "Te estamos inscribiendo en {{trainingName}}! Una vez que termines, verás la capacitación {{trainingName}} en la sección \"Todas tus capacitaciones\" del panel de control de tu equipo.",
				"title": "Inscripción en progreso"
			},
			"placeholder": {
				"incorrectMember": "Miembro de equipo incorrecto incorrecto. Por favor, contacta a la organización para obtener más información.",
				"title": "Sin elementos"
			},
			"subtitle": "Selecciona <span>inscribirte</span> para agregar un programa de formación a tu panel de control.",
			"title": "<span>Entrenamiento</span> disponible"
		}
	}
}
